import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { motion, AnimatePresence } from 'framer-motion';
import { createPortal } from 'react-dom';
import {
  User,
  Mail,
  Phone,
  MapPin,
  Calendar,
  Globe,
  Edit2,
  Camera,
  X,
  Check,
  AlertCircle,
  Sun,
  Moon,
  ArrowLeft,
  Building2,
  Hash,
  Flag,
  Activity,
  CheckCircle2,
  Clock,
  UserCheck,
  Star,
  Award,
  TrendingUp,
  Shield,
  Upload,
  Eye,
  EyeOff,
  Lock,
  Briefcase,
  Home,
  Heart,
  Users,
  Settings,
  Save,
  Loader2,
  Plus,
  Trash2,
  Image,
  Info
} from 'lucide-react';

import { useTheme } from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';

import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import DatePicker from 'react-datepicker';

// Supabase client
const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY
);

export const cities = [
  { name: 'Adana' },
  { name: 'Adıyaman' },
  { name: 'Afyonkarahisar' },
  { name: 'Ağrı' },
  { name: 'Amasya' },
  { name: 'Ankara' },
  { name: 'Antalya' },
  { name: 'Artvin' },
  { name: 'Aydın' },
  { name: 'Balıkesir' },
  { name: 'Bilecik' },
  { name: 'Bingöl' },
  { name: 'Bitlis' },
  { name: 'Bolu' },
  { name: 'Burdur' },
  { name: 'Bursa' },
  { name: 'Çanakkale' },
  { name: 'Çankırı' },
  { name: 'Çorum' },
  { name: 'Denizli' },
  { name: 'Diyarbakır' },
  { name: 'Edirne' },
  { name: 'Elazığ' },
  { name: 'Erzincan' },
  { name: 'Erzurum' },
  { name: 'Eskişehir' },
  { name: 'Gaziantep' },
  { name: 'Giresun' },
  { name: 'Gümüşhane' },
  { name: 'Hakkari' },
  { name: 'Hatay' },
  { name: 'Isparta' },
  { name: 'Mersin' },
  { name: 'İstanbul' },
  { name: 'İzmir' },
  { name: 'Kars' },
  { name: 'Kastamonu' },
  { name: 'Kayseri' },
  { name: 'Kırklareli' },
  { name: 'Kırşehir' },
  { name: 'Kocaeli' },
  { name: 'Konya' },
  { name: 'Kütahya' },
  { name: 'Malatya' },
  { name: 'Manisa' },
  { name: 'Kahramanmaraş' },
  { name: 'Mardin' },
  { name: 'Muğla' },
  { name: 'Muş' },
  { name: 'Nevşehir' },
  { name: 'Niğde' },
  { name: 'Ordu' },
  { name: 'Rize' },
  { name: 'Sakarya' },
  { name: 'Samsun' },
  { name: 'Siirt' },
  { name: 'Sinop' },
  { name: 'Sivas' },
  { name: 'Tekirdağ' },
  { name: 'Tokat' },
  { name: 'Trabzon' },
  { name: 'Tunceli' },
  { name: 'Şanlıurfa' },
  { name: 'Uşak' },
  { name: 'Van' },
  { name: 'Yozgat' },
  { name: 'Zonguldak' },
  { name: 'Aksaray' },
  { name: 'Bayburt' },
  { name: 'Karaman' },
  { name: 'Kırıkkale' },
  { name: 'Batman' },
  { name: 'Şırnak' },
  { name: 'Bartın' },
  { name: 'Ardahan' },
  { name: 'Iğdır' },
  { name: 'Yalova' },
  { name: 'Karabük' },
  { name: 'Kilis' },
  { name: 'Osmaniye' },
  { name: 'Düzce' }
]; 

// Ülke listesi (Örnek)

const countryOptions = [
  { value: 'Türkiye', label: 'Türkiye' },
  { value: 'Amerika Birleşik Devletleri', label: 'Amerika Birleşik Devletleri' },
  { value: 'Birleşik Krallık', label: 'Birleşik Krallık' },
  { value: 'Almanya', label: 'Almanya' },
  { value: 'Fransa', label: 'Fransa' },
  { value: 'İtalya', label: 'İtalya' },
  { value: 'İspanya', label: 'İspanya' },
  { value: 'Polonya', label: 'Polonya' },
  { value: 'Rusya', label: 'Rusya' },
  { value: 'Hindistan', label: 'Hindistan' },
  { value: 'Çin', label: 'Çin' },
  { value: 'Japonya', label: 'Japonya' },
  { value: 'Güney Kore', label: 'Güney Kore' },
  { value: 'Brezilya', label: 'Brezilya' },
  { value: 'Kanada', label: 'Kanada' },
  { value: 'Avustralya', label: 'Avustralya' },
  { value: 'Meksika', label: 'Meksika' },
  { value: 'Güney Afrika', label: 'Güney Afrika' },
  { value: 'Nijerya', label: 'Nijerya' },
  { value: 'Mısır', label: 'Mısır' },
  { value: 'Arjantin', label: 'Arjantin' },
  { value: 'Şili', label: 'Şili' },
  { value: 'Kolombiya', label: 'Kolombiya' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Singapur', label: 'Singapur' },
  { value: 'Malezya', label: 'Malezya' },
  { value: 'Filipinler', label: 'Filipinler' },
  { value: 'Tayland', label: 'Tayland' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'Endonezya', label: 'Endonezya' },
  { value: 'Kore Cumhuriyeti', label: 'Kore Cumhuriyeti' },
  { value: 'Suudi Arabistan', label: 'Suudi Arabistan' },
  { value: 'Birleşik Arap Emirlikleri', label: 'Birleşik Arap Emirlikleri' },
  { value: 'Kuveyt', label: 'Kuveyt' },
  { value: 'Katar', label: 'Katar' },
  { value: 'Umman', label: 'Umman' },
  { value: 'Bahreyn', label: 'Bahreyn' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Bangladeş', label: 'Bangladeş' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Yeni Zelanda', label: 'Yeni Zelanda' },
  { value: 'Finlandiya', label: 'Finlandiya' },
  { value: 'İsveç', label: 'İsveç' },
  { value: 'Norveç', label: 'Norveç' },
  { value: 'Danimarka', label: 'Danimarka' },
  { value: 'İzlanda', label: 'İzlanda' },
  { value: 'Yunanistan', label: 'Yunanistan' },
  { value: 'Macaristan', label: 'Macaristan' },
  { value: 'Avusturya', label: 'Avusturya' },
  { value: 'Belçika', label: 'Belçika' },
  { value: 'Hollanda', label: 'Hollanda' },
  { value: 'İsviçre', label: 'İsviçre' },
  { value: 'Çek Cumhuriyeti', label: 'Çek Cumhuriyeti' },
  { value: 'Slovakya', label: 'Slovakya' },
  { value: 'Romanya', label: 'Romanya' },
  { value: 'Bulgaristan', label: 'Bulgaristan' },
  { value: 'Ukrayna', label: 'Ukrayna' },
  { value: 'Beyaz Rusya', label: 'Beyaz Rusya' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Azerbaycan', label: 'Azerbaycan' },
  { value: 'Gürcistan', label: 'Gürcistan' },
  { value: 'Ermenistan', label: 'Ermenistan' },
  { value: 'Kazakistan', label: 'Kazakistan' },
  { value: 'Kırgızistan', label: 'Kırgızistan' },
  { value: 'Tacikistan', label: 'Tacikistan' },
  { value: 'Türkmenistan', label: 'Türkmenistan' },
  { value: 'Özbekistan', label: 'Özbekistan' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Kamboçya', label: 'Kamboçya' },
  { value: 'Butan', label: 'Butan' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Maldivler', label: 'Maldivler' },
  { value: 'Timor-Leste', label: 'Timor-Leste' },
  { value: 'Karadağ', label: 'Karadağ' },
  { value: 'Sırbistan', label: 'Sırbistan' },
  { value: 'Bosna-Hersek', label: 'Bosna-Hersek' },
  { value: 'Kuzey Makedonya', label: 'Kuzey Makedonya' },
  { value: 'Arnavutluk', label: 'Arnavutluk' },
  { value: 'Hırvatistan', label: 'Hırvatistan' },
  { value: 'Slovenya', label: 'Slovenya' },
  { value: 'Estonya', label: 'Estonya' },
  { value: 'Letonya', label: 'Letonya' },
  { value: 'Litvanya', label: 'Litvanya' },
  { value: 'Lüksemburg', label: 'Lüksemburg' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Kıbrıs', label: 'Kıbrıs' },
  { value: 'İrlanda', label: 'İrlanda' },
  { value: 'Portekiz', label: 'Portekiz' },
  { value: 'Andorra', label: 'Andorra' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Vatikan', label: 'Vatikan' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'İran', label: 'İran' },
  { value: 'Irak', label: 'Irak' },
  { value: 'Suriye', label: 'Suriye' },
  { value: 'Lübnan', label: 'Lübnan' },
  { value: 'İsrail', label: 'İsrail' },
  { value: 'Filistin', label: 'Filistin' },
  { value: 'Ürdün', label: 'Ürdün' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Afganistan', label: 'Afganistan' },
  { value: 'Moğolistan', label: 'Moğolistan' },
  { value: 'Kuzey Kore', label: 'Kuzey Kore' },
  { value: 'Tayvan', label: 'Tayvan' },
  { value: 'Hong Kong', label: 'Hong Kong' },
  { value: 'Makao', label: 'Makao' },
  { value: 'Brunei', label: 'Brunei' },
  { value: 'Papua Yeni Gine', label: 'Papua Yeni Gine' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Solomon Adaları', label: 'Solomon Adaları' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Yeni Kaledonya', label: 'Yeni Kaledonya' },
  { value: 'Fransız Polinezyası', label: 'Fransız Polinezyası' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Kiribati', label: 'Kiribati' },
  { value: 'Tuvalu', label: 'Tuvalu' },
  { value: 'Nauru', label: 'Nauru' },
  { value: 'Palau', label: 'Palau' },
  { value: 'Mikronezya', label: 'Mikronezya' },
  { value: 'Marshall Adaları', label: 'Marshall Adaları' },
  { value: 'Cook Adaları', label: 'Cook Adaları' },
  { value: 'Niue', label: 'Niue' },
  { value: 'Tokelau', label: 'Tokelau' },
  { value: 'Amerikan Samoası', label: 'Amerikan Samoası' },
  { value: 'Guam', label: 'Guam' },
  { value: 'Kuzey Mariana Adaları', label: 'Kuzey Mariana Adaları' },
  { value: 'Amerikan Virjin Adaları', label: 'Amerikan Virjin Adaları' },
  { value: 'Porto Riko', label: 'Porto Riko' },
  { value: 'Bermuda', label: 'Bermuda' },
  { value: 'Grönland', label: 'Grönland' },
  { value: 'Faroe Adaları', label: 'Faroe Adaları' },
  { value: 'Cebelitarık', label: 'Cebelitarık' },
  { value: 'Jersey', label: 'Jersey' },
  { value: 'Guernsey', label: 'Guernsey' },
  { value: 'Man Adası', label: 'Man Adası' },
  { value: 'Falkland Adaları', label: 'Falkland Adaları' },
  { value: 'Güney Georgia ve Güney Sandwich Adaları', label: 'Güney Georgia ve Güney Sandwich Adaları' },
  { value: 'Britanya Hint Okyanusu Toprakları', label: 'Britanya Hint Okyanusu Toprakları' },
  { value: 'Anguilla', label: 'Anguilla' },
  { value: 'Antigua ve Barbuda', label: 'Antigua ve Barbuda' },
  { value: 'Aruba', label: 'Aruba' },
  { value: 'Bahamalar', label: 'Bahamalar' },
  { value: 'Barbados', label: 'Barbados' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Britanya Virjin Adaları', label: 'Britanya Virjin Adaları' },
  { value: 'Cayman Adaları', label: 'Cayman Adaları' },
  { value: 'Kosta Rika', label: 'Kosta Rika' },
  { value: 'Küba', label: 'Küba' },
  { value: 'Curaçao', label: 'Curaçao' },
  { value: 'Dominika', label: 'Dominika' },
  { value: 'Dominik Cumhuriyeti', label: 'Dominik Cumhuriyeti' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'Grenada', label: 'Grenada' },
  { value: 'Guadeloupe', label: 'Guadeloupe' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Jamaika', label: 'Jamaika' },
  { value: 'Martinique', label: 'Martinique' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Nikaragua', label: 'Nikaragua' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Saint Kitts ve Nevis', label: 'Saint Kitts ve Nevis' },
  { value: 'Saint Lucia', label: 'Saint Lucia' },
  { value: 'Saint Vincent ve Grenadines', label: 'Saint Vincent ve Grenadines' },
  { value: 'Sint Maarten', label: 'Sint Maarten' },
  { value: 'Trinidad ve Tobago', label: 'Trinidad ve Tobago' },
  { value: 'Turks ve Caicos Adaları', label: 'Turks ve Caicos Adaları' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Bolivya', label: 'Bolivya' },
  { value: 'Ekvador', label: 'Ekvador' },
  { value: 'Fransız Guyanası', label: 'Fransız Guyanası' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Surinam', label: 'Surinam' },
  { value: 'Cezayir', label: 'Cezayir' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Botsvana', label: 'Botsvana' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Kamerun', label: 'Kamerun' },
  { value: 'Cape Verde', label: 'Cape Verde' },
  { value: 'Orta Afrika Cumhuriyeti', label: 'Orta Afrika Cumhuriyeti' },
  { value: 'Çad', label: 'Çad' },
  { value: 'Komorlar', label: 'Komorlar' },
  { value: 'Kongo', label: 'Kongo' },
  { value: 'Demokratik Kongo Cumhuriyeti', label: 'Demokratik Kongo Cumhuriyeti' },
  { value: 'Cibuti', label: 'Cibuti' },
  { value: 'Ekvator Ginesi', label: 'Ekvator Ginesi' },
  { value: 'Eritre', label: 'Eritre' },
  { value: 'Etiyopya', label: 'Etiyopya' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambiya', label: 'Gambiya' },
  { value: 'Gana', label: 'Gana' },
  { value: 'Gine', label: 'Gine' },
  { value: 'Gine-Bissau', label: 'Gine-Bissau' },
  { value: 'Fildişi Sahili', label: 'Fildişi Sahili' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Liberya', label: 'Liberya' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Madagaskar', label: 'Madagaskar' },
  { value: 'Malavi', label: 'Malavi' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Moritanya', label: 'Moritanya' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Mayotte', label: 'Mayotte' },
  { value: 'Fas', label: 'Fas' },
  { value: 'Mozambik', label: 'Mozambik' },
  { value: 'Namibya', label: 'Namibya' },
  { value: 'Nijer', label: 'Nijer' },
  { value: 'Reunion', label: 'Reunion' },
  { value: 'Ruanda', label: 'Ruanda' },
  { value: 'Saint Helena', label: 'Saint Helena' },
  { value: 'Sao Tome ve Principe', label: 'Sao Tome ve Principe' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Seyşeller', label: 'Seyşeller' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Somali', label: 'Somali' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Güney Sudan', label: 'Güney Sudan' },
  { value: 'Svaziland', label: 'Svaziland' },
  { value: 'Tanzanya', label: 'Tanzanya' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Tunus', label: 'Tunus' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'Batı Sahra', label: 'Batı Sahra' },
  { value: 'Zambiya', label: 'Zambiya' },
  { value: 'Zimbabve', label: 'Zimbabve' },
];

// Cinsiyet seçenekleri
const genderOptions = [
  { value: 'male', label: 'Erkek' },
  { value: 'female', label: 'Kadın' },
  { value: 'other', label: 'Diğer' }
];

// Pozisyon seçenekleri (Örnek)

const positionOptions = [
  // Yönetim ve İdari Pozisyonlar
  { value: 'CEO (Genel Müdür)', label: 'CEO (Genel Müdür)' },
  { value: 'COO (Operasyon Direktörü)', label: 'COO (Operasyon Direktörü)' },
  { value: 'CFO (Finans Direktörü)', label: 'CFO (Finans Direktörü)' },
  { value: 'Genel Müdür', label: 'Genel Müdür' },
  { value: 'İK Müdürü', label: 'İK Müdürü' },
  { value: 'Proje Yöneticisi', label: 'Proje Yöneticisi' },
  { value: 'Satınalma Müdürü', label: 'Satınalma Müdürü' },
  { value: 'Operasyon Yöneticisi', label: 'Operasyon Yöneticisi' },
  { value: 'Pazarlama Müdürü', label: 'Pazarlama Müdürü' },

  // Mühendislik ve Teknik Pozisyonlar
  { value: 'Yazılım Mühendisi', label: 'Yazılım Mühendisi' },
  { value: 'Elektrik & Elektronik Mühendisi', label: 'Elektrik & Elektronik Mühendisi' },
  { value: 'Makine Mühendisi', label: 'Makine Mühendisi' },
  { value: 'İnşaat Mühendisi', label: 'İnşaat Mühendisi' },
  { value: 'Endüstri Mühendisi', label: 'Endüstri Mühendisi' },
  { value: 'Sistem Yöneticisi', label: 'Sistem Yöneticisi' },
  { value: 'Web Geliştirici', label: 'Web Geliştirici' },
  { value: 'Veritabanı Yöneticisi', label: 'Veritabanı Yöneticisi' },
  { value: 'Ağ Mühendisi', label: 'Ağ Mühendisi' },
  { value: 'CAD Tasarımcı', label: 'CAD Tasarımcı' },
  { value: '3D Modelleme Uzmanı', label: '3D Modelleme Uzmanı' },

  // Pazarlama ve Satış Pozisyonları
  { value: 'Pazarlama Uzmanı', label: 'Pazarlama Uzmanı' },
  { value: 'Dijital Pazarlama Uzmanı', label: 'Dijital Pazarlama Uzmanı' },
  { value: 'Satış Müdürü', label: 'Satış Müdürü' },
  { value: 'Satış Temsilcisi', label: 'Satış Temsilcisi' },
  { value: 'Satınalma Uzmanı', label: 'Satınalma Uzmanı' },
  { value: 'Ürün Yöneticisi', label: 'Ürün Yöneticisi' },
  { value: 'Sosyal Medya Yöneticisi', label: 'Sosyal Medya Yöneticisi' },
  { value: 'İhracat Satış Uzmanı', label: 'İhracat Satış Uzmanı' },

  // İnsan Kaynakları Pozisyonları
  { value: 'İnsan Kaynakları Uzmanı', label: 'İnsan Kaynakları Uzmanı' },
  { value: 'İşe Alım Uzmanı', label: 'İşe Alım Uzmanı' },
  { value: 'Performans Değerlendirme Uzmanı', label: 'Performans Değerlendirme Uzmanı' },
  { value: 'Eğitim ve Gelişim Uzmanı', label: 'Eğitim ve Gelişim Uzmanı' },
  { value: 'İK Direktörü', label: 'İK Direktörü' },

  // Hizmet ve Perakende Pozisyonları
  { value: 'Mağaza Müdürü', label: 'Mağaza Müdürü' },
  { value: 'Satış Elemanı', label: 'Satış Elemanı' },
  { value: 'Müşteri Temsilcisi', label: 'Müşteri Temsilcisi' },
  { value: 'Kasiyer', label: 'Kasiyer' },
  { value: 'Restoran Müdürü', label: 'Restoran Müdürü' },
  { value: 'Garson', label: 'Garson' },
  { value: 'Aşçı', label: 'Aşçı' },

  // Sağlık ve Sosyal Hizmetler Pozisyonları
  { value: 'Doktor', label: 'Doktor' },
  { value: 'Hemşire', label: 'Hemşire' },
  { value: 'Ebe', label: 'Ebe' },
  { value: 'Psikolog', label: 'Psikolog' },
  { value: 'Fizyoterapist', label: 'Fizyoterapist' },
  { value: 'Diş Hekimi', label: 'Diş Hekimi' },
  { value: 'Sosyal Hizmet Uzmanı', label: 'Sosyal Hizmet Uzmanı' },
  { value: 'Sağlık Teknisyeni', label: 'Sağlık Teknisyeni' },

  // Finans ve Muhasebe Pozisyonları
  { value: 'Muhasebe Uzmanı', label: 'Muhasebe Uzmanı' },
  { value: 'Finansal Analist', label: 'Finansal Analist' },
  { value: 'Denetçi', label: 'Denetçi' },
  { value: 'Vergi Uzmanı', label: 'Vergi Uzmanı' },
  { value: 'Hazine Yöneticisi', label: 'Hazine Yöneticisi' },
  { value: 'Banka Memuru', label: 'Banka Memuru' },

  // Yaratıcı ve Tasarım Pozisyonları
  { value: 'Grafik Tasarımcı', label: 'Grafik Tasarımcı' },
  { value: 'Web Tasarımcısı', label: 'Web Tasarımcısı' },
  { value: 'İç Mekan Tasarımcısı', label: 'İç Mekan Tasarımcısı' },
  { value: 'Moda Tasarımcısı', label: 'Moda Tasarımcısı' },
  { value: 'Video Editörü', label: 'Video Editörü' },
  { value: 'Animatör', label: 'Animatör' },
  { value: 'Fotoğrafçı', label: 'Fotoğrafçı' },
  { value: 'Sanat Direktörü', label: 'Sanat Direktörü' },

  // Eğitim ve Akademik Pozisyonlar
  { value: 'Öğretmen', label: 'Öğretmen' },
  { value: 'Eğitim Uzmanı', label: 'Eğitim Uzmanı' },
  { value: 'Rehberlik ve Psikolojik Danışman', label: 'Rehberlik ve Psikolojik Danışman' },
  { value: 'Akademisyen', label: 'Akademisyen' },
  { value: 'Eğitim Koçu', label: 'Eğitim Koçu' },
  { value: 'Okul Müdürü', label: 'Okul Müdürü' },

  // Lojistik ve Depo Yönetimi Pozisyonları
  { value: 'Lojistik Yöneticisi', label: 'Lojistik Yöneticisi' },
  { value: 'Depo Sorumlusu', label: 'Depo Sorumlusu' },
  { value: 'Sevkiyat Koordinatörü', label: 'Sevkiyat Koordinatörü' },
  { value: 'Tedarik Zinciri Uzmanı', label: 'Tedarik Zinciri Uzmanı' },
  { value: 'Forklift Operatörü', label: 'Forklift Operatörü' },

  // Hukuk ve Danışmanlık Pozisyonları
  { value: 'Avukat', label: 'Avukat' },
  { value: 'Hukuk Müşaviri', label: 'Hukuk Müşaviri' },
  { value: 'İcra Memuru', label: 'İcra Memuru' },
  { value: 'Patent Uzmanı', label: 'Patent Uzmanı' },
  { value: 'Danışman', label: 'Danışman' },

  // İnşaat ve Yapı Pozisyonları
  { value: 'İnşaat Mühendisi', label: 'İnşaat Mühendisi' },
  { value: 'Proje Koordinatörü', label: 'Proje Koordinatörü' },
  { value: 'Elektrik Teknikeri', label: 'Elektrik Teknikeri' },
  { value: 'İnşaat Ustası', label: 'İnşaat Ustası' },
  { value: 'Şantiye Şefi', label: 'Şantiye Şefi' },
  { value: 'Yapı Ressamı', label: 'Yapı Ressamı' },

  // Bilgi Teknolojileri Pozisyonları
  { value: 'Yazılım Geliştiricisi', label: 'Yazılım Geliştiricisi' },
  { value: 'Sistem Analisti', label: 'Sistem Analisti' },
  { value: 'Test Uzmanı', label: 'Test Uzmanı' },
  { value: 'UI/UX Tasarımcı', label: 'UI/UX Tasarımcı' },
  { value: 'Teknik Destek Uzmanı', label: 'Teknik Destek Uzmanı' },
  { value: 'Siber Güvenlik Uzmanı', label: 'Siber Güvenlik Uzmanı' },
  { value: 'Lise Stajyeri', label: 'Lise Stajyeri' },
  { value: 'Üniversite Stajyeri', label: 'Üniversite Stajyeri' },
  { value: 'Diğer..', label: 'Diğer..' },
];

// React Select için özel stil objesi (koyu/açık tema desteği)
const customReactSelectStyles = (isDark) => ({
  control: (base, state) => ({
    ...base,
    minHeight: '48px',
    paddingLeft: '2.5rem',
    borderRadius: '0.75rem',
    borderColor: isDark ? 'rgba(255,255,255,0.1)' : '#e5e7eb',
    backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : '#fff',
    boxShadow: state.isFocused
      ? '0 0 0 2px rgba(59, 130, 246, 0.5)'
      : 'none',
    '&:hover': {
      borderColor: isDark ? 'rgba(255,255,255,0.2)' : '#d1d5db',
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '0.75rem',
    borderColor: isDark ? 'rgba(255,255,255,0.1)' : '#e5e7eb',
    backgroundColor: isDark ? '#1f2937' : '#fff',
  }),
  singleValue: (base) => ({
    ...base,
    color: isDark ? '#fff' : '#111827',
  }),
  placeholder: (base) => ({
    ...base,
    color: isDark ? '#9ca3af' : '#6b7280',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#3b82f6'
      : state.isFocused
      ? isDark
        ? 'rgba(59, 130, 246, 0.1)'
        : '#f3f4f6'
      : 'transparent',
    color: state.isSelected ? '#fff' : isDark ? '#fff' : '#111827',
    cursor: 'pointer',
  }),
});

// TC Kimlik Numarası doğrulama fonksiyonu
const validateTCNo = (tcno) => {
  if (!tcno) return false;
  if (tcno.length !== 11) return false;
  if (tcno[0] === '0') return false;
  if (!/^\d+$/.test(tcno)) return false;

  let oddSum = 0;
  let evenSum = 0;
  let total = 0;

  for (let i = 0; i < 9; i++) {
    const digit = parseInt(tcno[i]);
    if (i % 2 === 0) {
      oddSum += digit;
    } else {
      evenSum += digit;
    }
    total += digit;
  }

  if ((oddSum * 7 - evenSum) % 10 !== parseInt(tcno[9])) return false;
  if ((total + parseInt(tcno[9])) % 10 !== parseInt(tcno[10])) return false;

  return true;
};

// E-posta doğrulama (basit)
const validateEmailFormat = (email) => {
  if (!email) return false;
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
};

// Profil tamamlanma yüzdesi
const calculateProfileCompletion = (profile) => {
  if (!profile) return 0;

  const fields = [
    'first_name',
    'last_name',
    'email',
    'phone',
    'job_position',
    'website',
    'address',
    'country',
    'city',
    'birth_date',
    'gender',
    'national_id',
    'postal_code',
    'profile_photo_url'
  ];

  const filledFields = fields.filter(field => {
    const value = profile[field];
    return value !== null && value !== undefined && value !== '';
  });

  return Math.round((filledFields.length / fields.length) * 100);
};

// Modern avatar component
const ModernAvatar = ({ src, name, size = "xl", isEditing, onPhotoChange, previewPhoto, gender, onRemovePhoto, isLoading }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showPhotoOptions, setShowPhotoOptions] = useState(false);
  
  const sizeClasses = {
    sm: "w-12 h-12",
    md: "w-16 h-16", 
    lg: "w-24 h-24",
    xl: "w-32 h-32",
    "2xl": "w-40 h-40"
  };

  // Cinsiyete göre avatar gradient renkleri
  const getAvatarGradient = (gender) => {
    switch (gender) {
      case 'male':
        return 'from-blue-600 via-blue-700 to-indigo-600';
      case 'female':
        return 'from-pink-500 via-purple-600 to-pink-600';
      default:
        return 'from-emerald-500 via-blue-600 to-purple-600';
    }
  };

  const hasPhoto = src || previewPhoto;

  return (
    <motion.div 
      className="relative group"
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ 
        duration: 0.8,
        type: "spring",
        stiffness: 200,
        damping: 15
      }}
      whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <motion.div 
        className={`absolute -inset-0.5 bg-gradient-to-r ${getAvatarGradient(gender)} rounded-full blur opacity-60 group-hover:opacity-100 transition duration-300`}
        animate={{ 
          rotate: [0, 360],
        }}
        transition={{ 
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <motion.div 
        className={`relative ${sizeClasses[size]} rounded-full overflow-hidden border-4 border-white dark:border-gray-800 bg-white dark:bg-gray-800 shadow-lg`}
        whileHover={{ 
          boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 10px 10px -5px rgb(0 0 0 / 0.04)",
          transition: { duration: 0.2 }
        }}
      >
        <motion.img
          src={previewPhoto || src || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=gradient&color=fff&size=200`}
          alt={name}
          className="w-full h-full object-cover"
          initial={{ scale: 1.2, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
        />
        
        {/* Loading overlay */}
        {isLoading && (
          <motion.div 
            className="absolute inset-0 bg-black/50 flex items-center justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            >
              <Loader2 className="w-6 h-6 text-white" />
            </motion.div>
          </motion.div>
        )}
        
        {/* Photo edit overlay */}
        {isEditing && !isLoading && (
          <motion.div 
            className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
            whileHover={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
          >
            <motion.div
              className="flex items-center gap-2"
              initial={{ scale: 0 }}
              animate={{ scale: isHovered ? 1 : 0 }}
              transition={{ delay: 0.1, type: "spring", stiffness: 500, damping: 30 }}
            >
              {/* Upload/Change Photo Button */}
              <motion.label 
                className="p-2 bg-white/20 backdrop-blur-sm rounded-full cursor-pointer hover:bg-white/30 transition-colors z-10"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                title={hasPhoto ? "Fotoğrafı Değiştir" : "Fotoğraf Ekle"}
              >
                <Camera className="w-4 h-4 text-white" />
                <input
                  type="file"
                  accept="image/jpeg,image/png,image/gif,image/webp"
                  className="hidden"
                  onChange={(e) => {
                    onPhotoChange(e);
                    setShowPhotoOptions(false);
                  }}
                />
              </motion.label>
              
              {/* Remove Photo Button */}
              {hasPhoto && (
                <motion.button 
                  className="p-2 bg-red-500/80 backdrop-blur-sm rounded-full cursor-pointer hover:bg-red-600/90 transition-colors z-10"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    onRemovePhoto();
                    setShowPhotoOptions(false);
                  }}
                  title="Fotoğrafı Kaldır"
                >
                  <Trash2 className="w-4 h-4 text-white" />
                </motion.button>
              )}
              
              {/* Photo Options Button */}
              <motion.button 
                className="p-2 bg-blue-500/80 backdrop-blur-sm rounded-full cursor-pointer hover:bg-blue-600/90 transition-colors z-10"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowPhotoOptions(true)}
                title="Fotoğraf Seçenekleri"
              >
                <Settings className="w-4 h-4 text-white" />
              </motion.button>
            </motion.div>
          </motion.div>
        )}
      </motion.div>
      
      {/* Pulse effect for editing */}
      {isEditing && (
        <motion.div
          className={`absolute inset-0 rounded-full bg-gradient-to-r ${getAvatarGradient(gender)} opacity-30`}
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.1, 0.3]
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      )}
      
      {/* Photo status indicator */}
      {isEditing && (
        <motion.div
          className="absolute -bottom-2 -right-2 w-6 h-6 bg-white dark:bg-gray-800 rounded-full border-2 border-gray-200 dark:border-gray-700 flex items-center justify-center shadow-lg"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.5, type: "spring", stiffness: 500, damping: 30 }}
        >
          {isLoading ? (
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            >
              <Loader2 className="w-3 h-3 text-blue-600" />
            </motion.div>
          ) : hasPhoto ? (
            <Check className="w-3 h-3 text-green-600" />
          ) : (
            <Plus className="w-3 h-3 text-gray-400" />
          )}
        </motion.div>
      )}

      {/* Photo Options Modal */}
      {showPhotoOptions && createPortal(
        <AnimatePresence>
          <motion.div 
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowPhotoOptions(false)}
          >
            <motion.div
              className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md w-full shadow-2xl border border-gray-200 dark:border-gray-700"
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.5, opacity: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                  Profil Fotoğrafı
                </h3>
                <button
                  onClick={() => setShowPhotoOptions(false)}
                  className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
                >
                  <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="space-y-4">
                <p className="text-gray-600 dark:text-gray-400 text-center">
                  Fotoğrafınızı yönetin veya değiştirin
                </p>
                
                {/* Upload from File */}
                <label className="block">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      onPhotoChange(e);
                      setShowPhotoOptions(false);
                    }}
                    className="hidden"
                    disabled={isLoading}
                  />
                  <motion.div
                    className="flex items-center gap-3 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Upload className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                    <div>
                      <p className="font-medium text-blue-900 dark:text-blue-100">
                        Dosyadan Yükle
                      </p>
                      <p className="text-sm text-blue-700 dark:text-blue-300">
                        Bilgisayarınızdan fotoğraf seçin
                      </p>
                    </div>
                  </motion.div>
                </label>

                {/* Camera Capture */}
                <label className="block">
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={(e) => {
                      onPhotoChange(e);
                      setShowPhotoOptions(false);
                    }}
                    className="hidden"
                    disabled={isLoading}
                  />
                  <motion.div
                    className="flex items-center gap-3 p-4 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800 cursor-pointer hover:bg-green-100 dark:hover:bg-green-900/30 transition-colors"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Camera className="w-5 h-5 text-green-600 dark:text-green-400" />
                    <div>
                      <p className="font-medium text-green-900 dark:text-green-100">
                        Kamera ile Çek
                      </p>
                      <p className="text-sm text-green-700 dark:text-green-300">
                        Kameranızla yeni fotoğraf çekin
                      </p>
                    </div>
                  </motion.div>
                </label>

                {/* Remove Photo */}
                {hasPhoto && (
                  <motion.button
                    onClick={() => {
                      onRemovePhoto();
                      setShowPhotoOptions(false);
                    }}
                    className="w-full flex items-center gap-3 p-4 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-200 dark:border-red-800 cursor-pointer hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    disabled={isLoading}
                  >
                    <Trash2 className="w-5 h-5 text-red-600 dark:text-red-400" />
                    <div className="text-left">
                      <p className="font-medium text-red-900 dark:text-red-100">
                        Fotoğrafı Kaldır
                      </p>
                      <p className="text-sm text-red-700 dark:text-red-300">
                        Mevcut profil fotoğrafını sil
                      </p>
                    </div>
                  </motion.button>
                )}

                {/* Loading State */}
                {isLoading && (
                  <div className="flex items-center justify-center gap-3 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                    <Loader2 className="w-5 h-5 animate-spin text-blue-600 dark:text-blue-400" />
                    <span className="text-gray-600 dark:text-gray-400">
                      İşlem devam ediyor...
                    </span>
                  </div>
                )}
              </div>

              {/* File Requirements Info */}
              <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                <div className="flex items-start gap-3">
                  <Info className="w-5 h-5 text-gray-500 dark:text-gray-400 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Dosya Gereksinimleri
                    </p>
                    <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
                      <li>• Maksimum dosya boyutu: 25MB</li>
                      <li>• Desteklenen formatlar: JPG, PNG, GIF, WebP</li>
                      <li>• Önerilen boyut: 400x400 piksel</li>
                    </ul>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>,
        document.body
      )}
    </motion.div>
  );
};

// Modern stat card component
const StatCard = ({ icon: Icon, label, value, trend, color = "blue" }) => {
  const colorClasses = {
    blue: "from-blue-500 to-blue-600",
    green: "from-green-500 to-green-600", 
    purple: "from-purple-500 to-purple-600",
    orange: "from-orange-500 to-orange-600"
  };

  const shadowClasses = {
    blue: "shadow-blue-500/25",
    green: "shadow-green-500/25",
    purple: "shadow-purple-500/25", 
    orange: "shadow-orange-500/25"
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      whileHover={{ 
        scale: 1.03, 
        y: -5,
        transition: { duration: 0.2 }
      }}
      whileTap={{ scale: 0.98 }}
      className={`bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border border-gray-100 dark:border-gray-700 hover:shadow-xl hover:${shadowClasses[color]} transition-all duration-300 cursor-pointer`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <motion.p 
            className="text-sm font-medium text-gray-600 dark:text-gray-400"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1 }}
          >
            {label}
          </motion.p>
          <motion.p 
            className="text-2xl font-bold text-gray-900 dark:text-white mt-1"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
          >
            {value}
          </motion.p>
          {trend && (
            <motion.div 
              className="flex items-center mt-2"
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
            >
              <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
              <span className="text-sm text-green-500 font-medium">{trend}</span>
            </motion.div>
          )}
        </div>
        <motion.div 
          className={`p-3 rounded-xl bg-gradient-to-r ${colorClasses[color]} shadow-lg`}
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ 
            delay: 0.2,
            type: "spring", 
            stiffness: 500, 
            damping: 25 
          }}
          whileHover={{ 
            scale: 1.1, 
            rotate: 5,
            transition: { duration: 0.2 }
          }}
        >
          <Icon className="w-6 h-6 text-white" />
        </motion.div>
      </div>
    </motion.div>
  );
};

// Modern input component
const ModernInput = ({ 
  label, 
  icon: Icon, 
  type = "text", 
  value, 
  onChange, 
  disabled, 
  placeholder, 
  error, 
  required = false,
  description
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const { isDark } = useTheme();

  return (
    <motion.div 
      className="space-y-2"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <motion.div 
        className="relative"
        animate={{ 
          scale: isFocused ? 1.02 : 1,
        }}
        transition={{ duration: 0.2 }}
      >
        {Icon && (
          <motion.div
            animate={{ 
              color: isFocused ? '#3B82F6' : '#9CA3AF',
              scale: isFocused ? 1.1 : 1
            }}
            transition={{ duration: 0.2 }}
            className="absolute left-4 top-0 bottom-0 z-10 flex items-center justify-center"
          >
            <Icon className="w-5 h-5" />
          </motion.div>
        )}
        <input
          type={type === "password" ? (showPassword ? "text" : "password") : type}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={`
            w-full ${Icon ? 'pl-12' : 'pl-4'} ${type === "password" ? 'pr-12' : 'pr-4'} py-3.5 h-[50px]
            rounded-xl border transition-all duration-300
            focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500
            ${error 
              ? 'border-red-300 bg-red-50/50 dark:bg-red-900/10 dark:border-red-600' 
              : disabled
                ? 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700 cursor-not-allowed opacity-60'
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:shadow-sm'
            }
            text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400
          `}
        />
        {type === "password" && (
          <motion.button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-0 bottom-0 z-10 flex items-center justify-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </motion.button>
        )}
      </motion.div>
      {description && (
        <motion.p 
          className="text-xs text-gray-500 dark:text-gray-400"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
        >
          {description}
        </motion.p>
      )}
      {error && (
        <motion.p 
          className="text-sm text-red-600 dark:text-red-400 flex items-center gap-1"
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
        >
          <AlertCircle className="w-4 h-4" />
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};

// Modern section component
const ModernSection = ({ title, icon: Icon, children, badge }) => {
  return (
    <motion.div 
      className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border border-gray-100 dark:border-gray-700 hover:shadow-xl transition-all duration-300"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      whileHover={{ y: -2, transition: { duration: 0.2 } }}
    >
      <motion.div 
        className="flex items-center justify-between mb-6"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1, duration: 0.4 }}
      >
        <div className="flex items-center gap-3">
          <motion.div 
            className="p-2 bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-900/30 dark:to-blue-800/30 rounded-lg"
            whileHover={{ scale: 1.1, rotate: 5 }}
            transition={{ duration: 0.2 }}
          >
            <Icon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </motion.div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">{title}</h3>
          {badge && (
            <motion.span 
              className="px-3 py-1 bg-gradient-to-r from-blue-100 to-blue-200 dark:from-blue-900/30 dark:to-blue-800/30 text-blue-600 dark:text-blue-400 text-xs font-medium rounded-full"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 500, damping: 30 }}
            >
              {badge}
            </motion.span>
          )}
        </div>
      </motion.div>
      <motion.div 
        className="space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};

// Progress circle component
const ProgressCircle = ({ percentage, size = 120, gender }) => {
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  // Cinsiyete göre progress circle renkleri
  const getProgressColor = (gender) => {
    switch (gender) {
      case 'male':
        return 'text-blue-600';
      case 'female':
        return 'text-pink-500';
      default:
        return 'text-emerald-600';
    }
  };

  const getProgressGradient = (gender) => {
    switch (gender) {
      case 'male':
        return 'url(#blueGradient)';
      case 'female':
        return 'url(#pinkGradient)';
      default:
        return 'url(#emeraldGradient)';
    }
  };

  return (
    <motion.div 
      className="relative"
      initial={{ scale: 0, rotate: -90 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ 
        duration: 0.8,
        type: "spring",
        stiffness: 200,
        damping: 20
      }}
    >
      <svg width={size} height={size} className="transform -rotate-90">
        <defs>
          <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3B82F6" />
            <stop offset="100%" stopColor="#1D4ED8" />
          </linearGradient>
          <linearGradient id="pinkGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#EC4899" />
            <stop offset="100%" stopColor="#BE185D" />
          </linearGradient>
          <linearGradient id="emeraldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#047857" />
          </linearGradient>
        </defs>
        
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth="6"
          fill="none"
          className="text-gray-200 dark:text-gray-700"
        />
        
        {/* Progress circle */}
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={getProgressGradient(gender)}
          strokeWidth="6"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          className="drop-shadow-lg"
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset }}
          transition={{ 
            duration: 2,
            ease: "easeInOut",
            delay: 0.5
          }}
        />
      </svg>
      
      {/* Center content */}
      <motion.div 
        className="absolute inset-0 flex items-center justify-center"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
      >
        <div className="text-center">
          <motion.span 
            className="text-2xl font-bold text-white dark:text-white"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5 }}
          >
            {percentage}%
          </motion.span>
          <motion.p 
            className="text-xs text-white dark:text-white font-medium"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.7 }}
          >
            Tamamlandı
          </motion.p>
        </div>
      </motion.div>
    </motion.div>
  );
};

const ProfileInfo = () => {
  const { isDark, toggleTheme } = useTheme();
  const [userProfile, setUserProfile] = useState(null);
  const [editedProfile, setEditedProfile] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [privacySettings, setPrivacySettings] = useState({
    showPhone: true,
    showEmail: true,
    showAddress: false,
    showBirthDate: false
  });
  const [passwordLastChanged, setPasswordLastChanged] = useState(null);
  const [achievements, setAchievements] = useState({
    profileCompletion: 0,
    recentActivity: 0,
    totalTasks: 0,
    completedTasks: 0,
    participationRate: 0,
    accountAge: 0
  });
  const [activeTab, setActiveTab] = useState('personal');
  const [skillInput, setSkillInput] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [editingBio, setEditingBio] = useState(false);
  const [editingSkills, setEditingSkills] = useState(false);
  const [tempBio, setTempBio] = useState('');
  const [tempSkills, setTempSkills] = useState('');
  const navigate = useNavigate();

  const [stats, setStats] = useState([
    { icon: Activity, label: 'Atanan Görevler', value: '0', color: 'blue', trend: null },
    { icon: CheckCircle2, label: 'Tamamlanan', value: '0', color: 'green', trend: null },
    { icon: Clock, label: 'Hesap Yaşı', value: '0 gün', color: 'purple', trend: null },
    { icon: UserCheck, label: 'Katılım Oranı', value: '%0', color: 'orange', trend: null },
  ]);

  // Düzenlenmiş profil
  const [newProfilePhoto, setNewProfilePhoto] = useState(null);
  const [isPhotoUploading, setIsPhotoUploading] = useState(false);

  // Validation states
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [emailError, setEmailError] = useState('');
  const [tcError, setTcError] = useState('');

  // Profil verisini çekme
  const fetchUserProfile = async () => {
    try {
      setIsLoading(true);
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (userError) throw userError;
      if (!user?.email) throw new Error('Kullanıcı bulunamadı');

      const { data: profile, error: profileError } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('email', user.email)
        .single();

      if (profileError) throw profileError;

      setUserProfile(profile);
      setEditedProfile(profile);
      
      // Set biography and skills initial values
      setTempBio(profile.biography || '');
      setTempSkills(profile.skills || '');

      if (profile.id) {
        // Fetch achievements data
        const achievementsData = await calculateUserStats(profile.id);
        if (achievementsData) {
          setAchievements({
            profileCompletion: achievementsData.profileCompletion || 0,
            recentActivityRate: achievementsData.recentActivityRate || 0,
            totalTasks: achievementsData.totalTasks || 0,
            completedTasks: achievementsData.completedTasks || 0,
            participationRate: achievementsData.participationRate || 0,
            accountAge: achievementsData.accountAge || 0
          });
        }

        // Fetch privacy settings
        await fetchPrivacySettings(profile.id);
      }

      if (user) {
        await fetchPasswordChangeDate(user);
      }

    } catch (error) {
      console.error('Error fetching profile:', error);
      toast.error('Profil yüklenemedi');
    } finally {
      setIsLoading(false);
    }
  };

  // Şifre değişiklik tarihini çekme
  const fetchPasswordChangeDate = async (user) => {
    try {
      // Auth kullanıcısının updated_at bilgisini al
      // Bu tarih genellikle şifre değişiklerinde güncellenir
      if (user && user.updated_at) {
        setPasswordLastChanged(new Date(user.updated_at));
      } else {
        // Eğer updated_at yoksa created_at'i kullan
        setPasswordLastChanged(user.created_at ? new Date(user.created_at) : null);
      }
    } catch (error) {
      console.error('Error fetching password change date:', error);
      setPasswordLastChanged(null);
    }
  };

  // Şifre değişiklik tarihini formatlama
  const formatPasswordChangeDate = (date) => {
    if (!date) return 'Bilinmiyor';
    
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) {
      return 'Bugün';
    } else if (diffDays === 1) {
      return '1 gün önce';
    } else if (diffDays < 30) {
      return `${diffDays} gün önce`;
    } else if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return months === 1 ? '1 ay önce' : `${months} ay önce`;
    } else {
      const years = Math.floor(diffDays / 365);
      return years === 1 ? '1 yıl önce' : `${years} yıl önce`;
    }
  };

  // Telefon numarası formatlama
  const formatPhoneNumber = (phone) => {
    if (!phone) return 'Belirtilmemiş';
    
    // Sadece rakamları al
    const cleaned = phone.replace(/\D/g, '');
    
    // Türkiye numarası kontrolü ve formatlama
    if (cleaned.startsWith('90') && cleaned.length === 12) {
      // 905551234567 -> +90 (555) 123 4567
      const countryCode = cleaned.substring(0, 2);
      const areaCode = cleaned.substring(2, 5);
      const firstPart = cleaned.substring(5, 8);
      const secondPart = cleaned.substring(8, 12);
      return `+${countryCode} (${areaCode}) ${firstPart} ${secondPart}`;
    } else if (cleaned.startsWith('5') && cleaned.length === 10) {
      // 5551234567 -> +90 (555) 123 4567
      const areaCode = cleaned.substring(0, 3);
      const firstPart = cleaned.substring(3, 6);
      const secondPart = cleaned.substring(6, 10);
      return `+90 (${areaCode}) ${firstPart} ${secondPart}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('0')) {
      // 05551234567 -> +90 (555) 123 4567
      const areaCode = cleaned.substring(1, 4);
      const firstPart = cleaned.substring(4, 7);
      const secondPart = cleaned.substring(7, 11);
      return `+90 (${areaCode}) ${firstPart} ${secondPart}`;
    }
    
    // Diğer ülke kodları veya bilinmeyen formatlar için basit formatlama
    if (cleaned.length >= 10) {
      return `+${cleaned}`;
    }
    
    return phone; // Orijinal halini döndür
  };

  // Gizlilik ayarlarını çekme
  const fetchPrivacySettings = async (userId) => {
    try {
      const { data: securityData, error } = await supabase
        .from('security_settings')
        .select('public_profile, data_sharing, activity_tracking, login_notifications, device_history')
        .eq('user_id', userId)
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Privacy settings fetch error:', error);
        return;
      }

      if (securityData) {
        setPrivacySettings({
          public_profile: securityData.public_profile || false,
          login_notifications: securityData.login_notifications !== false, // Varsayılan true
          data_sharing: securityData.data_sharing || false,
          activity_tracking: securityData.activity_tracking !== false, // Varsayılan true
          device_history: securityData.device_history !== false // Varsayılan true
        });
      }
    } catch (error) {
      console.error('Error fetching privacy settings:', error);
      // Hata durumunda varsayılan değerleri koru
    }
  };

  // Gizlilik ayarlarını kaydetme
  const savePrivacySettings = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        console.error('No active session');
        return;
      }

      console.log('Saving privacy settings for user:', session.user.id);
      console.log('Settings to save:', privacySettings);

      // Önce mevcut kayıt var mı kontrol et
      const { data: existingSettings } = await supabase
        .from('security_settings')
        .select('id')
        .eq('user_id', session.user.id)
        .single();

      const settingsData = {
        user_id: session.user.id,
        public_profile: privacySettings.public_profile,
        login_notifications: privacySettings.login_notifications,
        data_sharing: privacySettings.data_sharing,
        activity_tracking: privacySettings.activity_tracking,
        device_history: privacySettings.device_history,
        updated_at: new Date().toISOString()
      };

      console.log('Data to save:', settingsData);

      if (existingSettings) {
        // Güncelle
        console.log('Updating existing settings');
        const { data, error } = await supabase
          .from('security_settings')
          .update(settingsData)
          .eq('user_id', session.user.id)
          .select();
        
        if (error) {
          console.error('Update error:', error);
          throw error;
        }
        console.log('Update successful:', data);
      } else {
        // Yeni kayıt oluştur
        console.log('Creating new settings');
        const { data, error } = await supabase
          .from('security_settings')
          .insert([{
            ...settingsData,
            two_factor_enabled: false,
            password_change_interval: '90',
            session_timeout: '30',
            created_at: new Date().toISOString()
          }])
          .select();
        
        if (error) {
          console.error('Insert error:', error);
          throw error;
        }
        console.log('Insert successful:', data);
      }

      toast.success('Gizlilik ayarları güncellendi');
    } catch (error) {
      console.error('Error saving privacy settings:', error);
      toast.error('Gizlilik ayarları kaydedilemedi: ' + error.message);
    }
  };

  // İlk yüklemede profil getir
  useEffect(() => {
    fetchUserProfile();
  }, []);

  // Profil fotoğrafı yönetimi
  const profilePhotoManager = {
    async removeFromStorage(photoUrl) {
      try {
        if (!photoUrl) throw new Error('Silinecek fotoğraf bulunamadı');
        const path = photoUrl.replace(/^.*\/profile-photos\//, 'profile-photos/');
        const { error: removeError } = await supabase.storage.from('profile-photos').remove([path]);
        if (removeError) {
          console.error('Storage remove error:', removeError);
          throw new Error('Fotoğraf storage\'dan silinemedi');
        }
      } catch (error) {
        console.error('Storage remove error:', error);
        throw error;
      }
    },

    async uploadToStorage(file) {
      try {
        if (!file) throw new Error('Yüklenecek dosya bulunamadı');
        const fileExt = file.name.split('.').pop();
        const fileName = `profile-photos/${Date.now()}.${fileExt}`;

        const { error: uploadError } = await supabase.storage
          .from('profile-photos')
          .upload(fileName, file);

        if (uploadError) {
          console.error('Upload error:', uploadError);
          throw new Error('Fotoğraf yüklenemedi');
        }

        const { data } = supabase.storage.from('profile-photos').getPublicUrl(fileName);
        if (!data?.publicUrl) {
          throw new Error('Fotoğraf URL\'i alınamadı');
        }
        return data.publicUrl;
      } catch (error) {
        console.error('Storage upload error:', error);
        throw error;
      }
    },

    async updateProfilePhotoUrl(email, photoUrl) {
      try {
        const { error: updateError } = await supabase
          .from('user_profiles')
          .update({
            profile_photo_url: photoUrl,
            updated_at: new Date().toISOString(),
          })
          .eq('email', email);

        if (updateError) {
          console.error('Profile update error:', updateError);
          throw new Error('Profil fotoğrafı güncellenemedi');
        }
        
        const { data: profile, error: fetchError } = await supabase
          .from('user_profiles')
          .select('*')
          .eq('email', email)
          .single();

        if (fetchError) {
          console.error('Profile fetch error:', fetchError);
          throw new Error('Güncel profil bilgileri alınamadı');
        }
        return profile;
      } catch (error) {
        console.error('Update error:', error);
        throw error;
      }
    },
  };

  // Kayıt fonksiyonu
  const handleSaveChanges = async () => {
    try {
      setIsSaving(true);
      
      // Validate email format
      if (editedProfile.email && !validateEmailFormat(editedProfile.email)) {
        setEmailError('Geçerli bir e-posta adresi girin');
        setIsEmailValid(false);
        toast.error('Lütfen geçerli bir e-posta adresi girin');
        return;
      }

      // Validate TC number
      if (editedProfile.tc_no && !validateTCNo(editedProfile.tc_no)) {
        setTcError('TC Kimlik No 11 haneli olmalı ve geçerli olmalıdır');
        toast.error('Geçerli bir TC Kimlik No girin');
        return;
      }

      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error('Kullanıcı oturumu bulunamadı');
        return;
      }

      let photoUrl = editedProfile.profile_photo_url;

      // Handle photo upload/removal
      if (newProfilePhoto) {
        const uploadedUrl = await profilePhotoManager.uploadToStorage(newProfilePhoto);
        if (uploadedUrl) {
          // Remove old photo if exists
          if (userProfile?.profile_photo_url) {
            await profilePhotoManager.removeFromStorage(userProfile.profile_photo_url);
          }
          photoUrl = uploadedUrl;
        }
      } else if (editedProfile.profile_photo_url === null && userProfile?.profile_photo_url) {
        // Photo was removed
        await profilePhotoManager.removeFromStorage(userProfile.profile_photo_url);
        photoUrl = null;
      }

      // Prepare profile data
      const profileData = {
        ...editedProfile,
        profile_photo_url: photoUrl,
        birth_date: editedProfile.birth_date ? editedProfile.birth_date.toISOString().split('T')[0] : null,
        updated_at: new Date().toISOString(),
      };

      // Update profile in database
      const { error: updateError } = await supabase
        .from('user_profiles')
        .update(profileData)
        .eq('email', user.email);

      if (updateError) throw updateError;

      // Update user's email in auth if changed
      if (editedProfile.email !== userProfile.email) {
        const { error: emailError } = await supabase.auth.updateUser({
          email: editedProfile.email
        });
        
        if (emailError) {
          console.error('Email update error:', emailError);
          toast.warning('E-posta güncellendi ancak doğrulama gerekli');
        }
      }

      // Fetch updated profile
      await fetchUserProfile();
      
      setIsEditing(false);
      setNewProfilePhoto(null);
      setPreviewPhoto(null);
      setEmailError('');
      setTcError('');
      setIsEmailValid(true);
      
      toast.success('Profil başarıyla güncellendi');
      
    } catch (error) {
      console.error('Profile update error:', error);
      toast.error('Profil güncellenemedi: ' + (error.message || 'Bilinmeyen hata'));
    } finally {
      setIsSaving(false);
    }
  };

  const handleSaveBio = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error('Kullanıcı oturumu bulunamadı');
        return;
      }

      const { error } = await supabase
        .from('user_profiles')
        .update({ biography: tempBio })
        .eq('email', user.email);

      if (error) throw error;

      // Update local state
      setUserProfile(prev => ({ ...prev, biography: tempBio }));
      setEditedProfile(prev => ({ ...prev, biography: tempBio }));
      setEditingBio(false);
      
      toast.success('Biyografi başarıyla güncellendi');
    } catch (error) {
      console.error('Error updating biography:', error);
      toast.error('Biyografi güncellenirken bir hata oluştu');
    }
  };

  const handleSaveSkills = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error('Kullanıcı oturumu bulunamadı');
        return;
      }

      const { error } = await supabase
        .from('user_profiles')
        .update({ skills: tempSkills })
        .eq('email', user.email);

      if (error) throw error;

      // Update local state
      setUserProfile(prev => ({ ...prev, skills: tempSkills }));
      setEditedProfile(prev => ({ ...prev, skills: tempSkills }));
      setEditingSkills(false);
      
      toast.success('Yetenekler başarıyla güncellendi');
    } catch (error) {
      console.error('Error updating skills:', error);
      toast.error('Yetenekler güncellenirken bir hata oluştu');
    }
  };

  const handleAddSkill = () => {
    if (skillInput.trim()) {
      const currentSkills = tempSkills ? tempSkills.split(',').filter(Boolean) : [];
      const newSkills = [...currentSkills, skillInput.trim()];
      setTempSkills(newSkills.join(','));
      setSkillInput('');
    }
  };

  const handleRemoveSkill = (skillToRemove) => {
    const currentSkills = tempSkills ? tempSkills.split(',').filter(Boolean) : [];
    const newSkills = currentSkills.filter(skill => skill !== skillToRemove);
    setTempSkills(newSkills.join(','));
  };

  // Ad formatlama
  const formatFirstName = (name) => {
    return name
      .split(' ')
      .map(
        (word) =>
          word.charAt(0).toLocaleUpperCase('tr-TR') +
          word.slice(1).toLocaleLowerCase('tr-TR')
      )
      .join(' ');
  };

  // Soyad formatlama
  const formatLastName = (name) => {
    return name.toLocaleUpperCase('tr-TR');
  };

  // Fotoğraf seçimi
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIsPhotoUploading(true);
      
      // Dosya boyutu kontrolü
      if (file.size > 25 * 1024 * 1024) {
        toast.error('Dosya boyutu 25MB\'dan büyük olamaz');
        setIsPhotoUploading(false);
        return;
      }
      
      // Dosya türü kontrolü
      const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        toast.error('Sadece JPG, PNG, GIF veya WebP formatı yükleyebilirsiniz');
        setIsPhotoUploading(false);
        return;
      }
      
      setNewProfilePhoto(file);
      
      // Preview için dosyayı oku
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewPhoto(reader.result);
        setIsPhotoUploading(false);
        toast.success('Fotoğraf seçildi! Kaydet butonuna tıklayarak profilinizi güncelleyin.');
      };
      reader.onerror = () => {
        setIsPhotoUploading(false);
        toast.error('Fotoğraf yüklenirken bir hata oluştu');
      };
      reader.readAsDataURL(file);
    }
  };

  // Fotoğraf kaldırma fonksiyonu
  const handleRemovePhoto = async () => {
    if (!userProfile?.profile_photo_url) {
      toast.error('Silinecek fotoğraf bulunamadı');
      return;
    }

    try {
      setIsPhotoUploading(true);
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error('Kullanıcı oturumu bulunamadı');
        return;
      }

      // Remove from storage
      await profilePhotoManager.removeFromStorage(userProfile.profile_photo_url);
      
      // Update database
      const { error: updateError } = await supabase
        .from('user_profiles')
        .update({ 
          profile_photo_url: null,
          updated_at: new Date().toISOString()
        })
        .eq('email', user.email);

      if (updateError) {
        console.error('Profile photo removal error:', updateError);
        throw new Error('Veritabanı güncellenemedi');
      }

      // Update local state
      setUserProfile(prev => ({ ...prev, profile_photo_url: null }));
      setEditedProfile(prev => ({ ...prev, profile_photo_url: null }));
      setPreviewPhoto(null);
      
      toast.success('Profil fotoğrafı başarıyla kaldırıldı');
      
    } catch (error) {
      console.error('Profile photo removal error:', error);
      toast.error('Fotoğraf kaldırılırken bir hata oluştu: ' + (error.message || 'Bilinmeyen hata'));
    } finally {
      setIsPhotoUploading(false);
    }
  };

  // Kullanıcı istatistiklerini hesaplama
  const calculateUserStats = async (userId) => {
    try {
      // En basit yaklaşım: Tüm görevleri getir ve JavaScript ile filtrele
      const { data: allTasks, error: tasksError } = await supabase
        .from('tasks')
        .select('*');

      if (tasksError) {
        console.error('Tasks fetch error:', tasksError);
      }

      // JavaScript ile kullanıcının atandığı görevleri filtrele
      const assignedTasks = allTasks?.filter(task => {
        if (!task.assigned_members || !Array.isArray(task.assigned_members)) {
          return false;
        }
        return task.assigned_members.some(member => 
          member.id === userId || 
          member.id === userId.toString() ||
          (typeof member === 'string' && member === userId) ||
          (typeof member === 'string' && member === userId.toString())
        );
      }) || [];

      // Tamamlanan görevleri filtrele
      const completedTasks = assignedTasks.filter(task => task.status === 'done');
      const totalAssignedTasks = assignedTasks.length;

      // Hesap oluşturma tarihinden bugüne kadar geçen süreyi hesapla
      const accountCreationDate = new Date(userProfile?.created_at);
      const currentDate = new Date();
      
      // Tarih geçerliliği kontrolü
      let daysDiff = 0;
      if (userProfile?.created_at && !isNaN(accountCreationDate.getTime())) {
        const accountTimeDiff = currentDate - accountCreationDate;
        daysDiff = Math.floor(accountTimeDiff / (1000 * 60 * 60 * 24));
        // Negatif değerleri önle
        daysDiff = Math.max(0, daysDiff);
      }

      // Katılım oranını hesapla (tamamlanan görevler / toplam atanan görevler)
      const participationRate = totalAssignedTasks > 0 
        ? Math.round((completedTasks.length / totalAssignedTasks) * 100)
        : 0;

      // Profil tamamlanma yüzdesini hesapla
      const profileCompletion = calculateProfileCompletion(userProfile);

      // Son 30 gündeki aktiviteyi hesapla
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      
      const recentTasks = assignedTasks.filter(task => {
        const taskDate = new Date(task.created_at);
        return taskDate >= thirtyDaysAgo;
      });

      const recentCompletedTasks = recentTasks.filter(task => task.status === 'done');
      const recentActivityRate = recentTasks.length > 0 
        ? Math.round((recentCompletedTasks.length / recentTasks.length) * 100)
        : 0;

      // İstatistikleri güncelle
      setStats([
        { 
          icon: Activity, 
          label: 'Atanan Görevler', 
          value: totalAssignedTasks.toString(),
          color: 'blue',
          trend: null,
          rawValue: totalAssignedTasks
        },
        { 
          icon: CheckCircle2, 
          label: 'Tamamlanan', 
          value: completedTasks.length.toString(),
          color: 'green',
          trend: null,
          rawValue: completedTasks.length
        },
        { 
          icon: Clock, 
          label: 'Hesap Yaşı', 
          value: daysDiff > 0 ? `${daysDiff} gün` : 'Bugün',
          color: 'purple',
          trend: null,
          rawValue: daysDiff
        },
        { 
          icon: UserCheck, 
          label: 'Katılım Oranı', 
          value: `%${participationRate}`,
          color: 'orange',
          trend: null,
          rawValue: participationRate
        },
      ]);

      // Başarılar için ekstra veriler döndür
      return {
        profileCompletion,
        recentActivityRate,
        totalTasks: totalAssignedTasks,
        completedTasks: completedTasks.length,
        participationRate,
        accountAge: daysDiff
      };

    } catch (error) {
      console.error('Stats calculation error:', error);
      // Hata durumunda varsayılan değerleri koru
      setStats([
        { icon: Activity, label: 'Atanan Görevler', value: '0', color: 'blue', trend: null, rawValue: 0 },
        { icon: CheckCircle2, label: 'Tamamlanan', value: '0', color: 'green', trend: null, rawValue: 0 },
        { icon: Clock, label: 'Hesap Yaşı', value: '0 gün', color: 'purple', trend: null, rawValue: 0 },
        { icon: UserCheck, label: 'Katılım Oranı', value: '%0', color: 'orange', trend: null, rawValue: 0 },
      ]);
      return {
        profileCompletion: 0,
        recentActivityRate: 0,
        totalTasks: 0,
        completedTasks: 0,
        participationRate: 0,
        accountAge: 0
      };
    }
  };

  // Website URL'ini formatlama
  const formatWebsiteUrl = (url) => {
    if (!url) return '';
    
    // URL'de protocol yoksa ekle
    if (url && !url.match(/^https?:\/\//)) {
      return `https://${url}`;
    }
    return url;
  };

  // Website görüntüleme formatı
  const displayWebsite = (url) => {
    if (!url) return 'www.orneksite.com';
    
    // Protocol'u kaldır ve sadece domain'i göster
    const cleanUrl = url.replace(/^https?:\/\//, '');
    
    // www. ile başlamıyorsa ekle
    if (!cleanUrl.startsWith('www.')) {
      return `www.${cleanUrl}`;
    }
    
    return cleanUrl;
  };

  // Başarı rozeti hesaplama
  const calculateAchievementLevel = (value, thresholds) => {
    if (value >= thresholds.gold) return { level: 'gold', color: 'from-yellow-400 to-yellow-600', text: 'Altın' };
    if (value >= thresholds.silver) return { level: 'silver', color: 'from-gray-400 to-gray-600', text: 'Gümüş' };
    if (value >= thresholds.bronze) return { level: 'bronze', color: 'from-orange-400 to-orange-600', text: 'Bronz' };
    return { level: 'none', color: 'from-gray-300 to-gray-400', text: 'Başlangıç' };
  };

  if (isLoading && !userProfile) {
    return (
<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white dark:from-gray-900 dark:to-gray-800">
  <div className="flex flex-col items-center justify-center text-center space-y-6">
    {/* Glow & Spinner */}
    <div className="relative w-20 h-20">
      {/* Arka plan parıltısı */}

      {/* Dönen daire */}
      <div className="absolute inset-0 rounded-full border-[6px] border-blue-400 border-t-transparent animate-spin"></div>

      {/* İç nokta */}
      <div className="relative w-4 h-4 top-[38%] left-[38%] rounded-full bg-blue-500"></div>
    </div>

    {/* Yazı */}
    <p className="text-lg text-gray-700 dark:text-gray-300 font-semibold tracking-wide animate-pulse">
      Profil bilgileri yükleniyor...
    </p>
  </div>
</div>

    );
  }

  const completionPercentage = calculateProfileCompletion(userProfile);

  // Cinsiyete göre gradient renkleri
  const getGenderGradient = (gender) => {
    switch (gender) {
      case 'male':
        return 'from-blue-600 via-blue-700 to-indigo-800';
      case 'female':
        return 'from-pink-500 via-purple-600 to-purple-700';
      default:
        return 'from-blue-600 via-purple-600 to-indigo-600';
    }
  };

  // Cinsiyete göre text renkleri
  const getGenderTextColor = (gender) => {
    switch (gender) {
      case 'male':
        return 'text-blue-100';
      case 'female':
        return 'text-pink-100';
      default:
        return 'text-blue-100';
    }
  };

  return (
    <motion.div 
      className="min-h-screen bg-gray-50 dark:bg-gray-900"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Modern Header */}
      <motion.div 
        className="sticky top-0 z-50 bg-white/80 dark:bg-gray-800/80 backdrop-blur-xl border-b border-gray-200 dark:border-gray-700"
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, type: "spring", stiffness: 400, damping: 30 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <motion.div 
              className="flex items-center gap-4"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate(-1)}
                className="p-2 rounded-xl bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </motion.button>
              <div>
                <h1 className="text-xl font-bold text-gray-900 dark:text-white">Profil Bilgileri</h1>
                <p className="text-sm text-gray-500 dark:text-gray-400">Kişisel bilgilerinizi yönetin</p>
              </div>
            </motion.div>

            <motion.div 
              className="flex items-center gap-3"
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              {/* Theme Toggle */}
              <motion.button
                whileHover={{ scale: 1.05, rotate: 180 }}
                whileTap={{ scale: 0.95 }}
                onClick={toggleTheme}
                className="p-2 rounded-xl bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
              </motion.button>

              {/* Edit Toggle */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  if (!isEditing) {
                    setEditedProfile({
                      ...userProfile,
                      birth_date: userProfile.birth_date ? new Date(userProfile.birth_date) : null,
                    });
                  }
                  setIsEditing(!isEditing);
                }}
                className={`
                  px-4 py-2 rounded-xl flex items-center gap-2 font-medium transition-all duration-300
                  ${isEditing
                    ? 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                    : 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                  }
                `}
              >
                <motion.div
                  animate={{ rotate: isEditing ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  {isEditing ? <X className="w-4 h-4" /> : <Edit2 className="w-4 h-4" />}
                </motion.div>
                <span>{isEditing ? 'İptal' : 'Düzenle'}</span>
              </motion.button>
            </motion.div>
          </div>
        </div>
      </motion.div>

      <motion.div 
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.6 }}
      >
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className={`relative bg-gradient-to-r ${getGenderGradient(userProfile?.gender)} rounded-3xl p-8 mb-8 overflow-hidden`}
        >
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
          
          <div className="relative flex flex-col lg:flex-row items-start lg:items-center gap-8">
            <div className="flex items-center gap-6">
              <ModernAvatar
                src={userProfile?.profile_photo_url}
                name={`${userProfile?.first_name} ${userProfile?.last_name}`}
                size="2xl"
                isEditing={isEditing}
                onPhotoChange={handlePhotoChange}
                previewPhoto={previewPhoto}
                gender={userProfile?.gender}
                onRemovePhoto={handleRemovePhoto}
                isLoading={isPhotoUploading}
              />
              
              <div className="text-white">
                <h2 className="text-3xl font-bold mb-2">
                  {userProfile?.first_name} {userProfile?.last_name}
                </h2>
                <p className={`text-xl ${getGenderTextColor(userProfile?.gender)} mb-3`}>{userProfile?.job_position}</p>
                <div className={`flex items-center gap-4 text-sm ${getGenderTextColor(userProfile?.gender)}`}>
                  <div className="flex items-center gap-1">
                    <Mail className="w-4 h-4" />
                    <span>{userProfile?.email}</span>
                </div>
                  {userProfile?.phone && (
                    <div className="flex items-center gap-1">
                      <Phone className="w-4 h-4" />
                      <span>{formatPhoneNumber(userProfile.phone)}</span>
                    </div>
                  )}
                  {userProfile?.city && (
                    <div className="flex items-center gap-1">
                      <MapPin className="w-4 h-4" />
                      <span>{userProfile.city}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="lg:ml-auto flex items-center gap-8">
              <div className="text-center">
                <ProgressCircle percentage={calculateProfileCompletion(userProfile)} gender={userProfile?.gender} />
                <p className="text-white font-medium mt-3">Profil Tamamlanma</p>
                <p className={`${getGenderTextColor(userProfile?.gender)} text-sm`}>Daha fazla bilgi ekleyin</p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Stats Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
        >
          {stats.map((stat, index) => (
            <StatCard
              key={index}
              icon={stat.icon}
              label={stat.label}
              value={stat.value}
              trend={stat.trend}
              color={stat.color}
            />
          ))}
        </motion.div>

        {/* Tab Navigation */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border border-gray-100 dark:border-gray-700 mb-8">
          <div className="relative bg-gray-100 dark:bg-gray-700 rounded-xl p-1">
            {/* Active tab indicator */}
            <motion.div
              layoutId="activeTab"
              className="absolute inset-y-1 bg-white dark:bg-gray-600 rounded-lg border border-gray-200 dark:border-gray-500"
              style={{
                width: `calc(${100/4}% - 4px)`,
                left: `calc(${['personal', 'work', 'contact', 'security'].indexOf(activeTab) * 25}% + 2px)`,
              }}
              transition={{
                type: "spring",
                stiffness: 500,
                damping: 30
              }}
            />
            
            <div className="relative flex">
              {[
                { id: 'personal', label: 'Kişisel Bilgiler', icon: User },
                { id: 'work', label: 'İş Bilgileri', icon: Briefcase },
                { id: 'contact', label: 'İletişim', icon: Phone },
                { id: 'security', label: 'Güvenlik', icon: Shield }
              ].map((tab, index) => (
                <motion.button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    relative flex items-center justify-center gap-2 flex-1 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 z-10
                    ${activeTab === tab.id
                      ? 'text-gray-900 dark:text-white'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                    }
                  `}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <motion.div
                    animate={{
                      scale: activeTab === tab.id ? 1.1 : 1,
                      color: activeTab === tab.id ? '#059669' : undefined
                    }}
                    transition={{ duration: 0.2 }}
                  >
                    <tab.icon className="w-4 h-4" />
                  </motion.div>
                  <span className="hidden sm:inline">{tab.label}</span>
                  
                  {/* Active indicator dot */}
                  {activeTab === tab.id && (
                    <motion.div
                      layoutId="activeDot"
                      className="absolute -bottom-1 left-1/2 w-1 h-1 bg-emerald-500 rounded-full"
                      style={{ transform: 'translateX(-50%)' }}
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", stiffness: 500, damping: 30 }}
                    />
                  )}
                </motion.button>
              ))}
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{ 
              duration: 0.4,
              type: "spring",
              stiffness: 400,
              damping: 25
            }}
          >
            {activeTab === 'personal' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <ModernSection title="Kişisel Bilgiler" icon={User} badge="Temel">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <ModernInput
                      label="Ad"
                      icon={User}
                        value={editedProfile?.first_name || ''}
                      onChange={(e) => setEditedProfile({
                            ...editedProfile,
                            first_name: formatFirstName(e.target.value),
                      })}
                        disabled={!isEditing}
                        placeholder="Adınız"
                      required
                    />
                    <ModernInput
                      label="Soyad"
                      icon={User}
                        value={editedProfile?.last_name || ''}
                      onChange={(e) => setEditedProfile({
                            ...editedProfile,
                            last_name: formatLastName(e.target.value),
                      })}
                        disabled={!isEditing}
                        placeholder="Soyadınız"
                      required
                      />
                </div>

                  <ModernInput
                    label="TC Kimlik No"
                    icon={Hash}
                    value={editedProfile?.national_id || ''}
                    onChange={(e) => {
                      const val = e.target.value;
                      if ((/^\d+$/.test(val) && val.length <= 11) || val === '') {
                        setEditedProfile({ ...editedProfile, national_id: val });
                        if (val.length === 11 && !validateTCNo(val)) {
                          setTcError('Geçersiz TC Kimlik Numarası');
                        } else {
                          setTcError('');
                        }
                      }
                    }}
                    disabled={!isEditing}
                    placeholder="11 haneli TC Kimlik No"
                    error={tcError}
                    description="TC Kimlik numaranız gizli tutulacak ve sadece kimlik doğrulama için kullanılacaktır."
                  />

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                        Cinsiyet
                  </label>
                      {!isEditing ? (
                        <div className="w-full px-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white">
                          {genderOptions.find(opt => opt.value === editedProfile?.gender)?.label || editedProfile?.gender || 'Belirtilmemiş'}
                        </div>
                      ) : (
                        <Select
                          options={genderOptions}
                          value={genderOptions.find(opt => opt.value === editedProfile?.gender)}
                          onChange={(option) => setEditedProfile({
                          ...editedProfile,
                            gender: option.value,
                          })}
                          isDisabled={!isEditing}
                          className="react-select-container"
                          classNamePrefix="react-select"
                          styles={customReactSelectStyles(isDark)}
                          placeholder="Cinsiyet seçiniz"
                        />
                      )}
                </div>

                <div>
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                        Doğum Tarihi
                  </label>
                  {!isEditing ? (
                        <div className="w-full px-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white">
                          {editedProfile?.birth_date
                            ? new Date(editedProfile.birth_date).toLocaleDateString('tr-TR')
                            : 'Belirtilmemiş'}
                    </div>
                  ) : (
                    <div className="relative">
                          <Calendar className="absolute left-4 top-0 bottom-0 w-5 h-5 text-gray-400 z-10 flex items-center justify-center" />
                          <DatePicker
                            selected={editedProfile?.birth_date || null}
                            onChange={(date) => setEditedProfile({
                              ...editedProfile,
                              birth_date: date,
                            })}
                            dateFormat="dd/MM/yyyy"
                            showYearDropdown
                            yearDropdownItemNumber={100}
                            scrollableYearDropdown
                        disabled={!isEditing}
                            className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                            placeholderText="Gün/Ay/Yıl"
                      />
                    </div>
                  )}
                </div>
                  </div>
                </ModernSection>

                <ModernSection title="Adres Bilgileri" icon={MapPin} badge="Konum">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    Ülke
                  </label>
                  {!isEditing ? (
                        <div className="w-full px-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white">
                          {editedProfile?.country
                            ? countryOptions.find(opt => opt.value === editedProfile.country)?.label || editedProfile.country
                            : 'Belirtilmemiş'}
                        </div>
                      ) : (
                      <Select
                        options={countryOptions}
                          value={countryOptions.find(opt => opt.value === editedProfile?.country)}
                          onChange={(option) => setEditedProfile({
                            ...editedProfile,
                            country: option.value,
                          })}
                        isDisabled={!isEditing}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        styles={customReactSelectStyles(isDark)}
                          placeholder="Ülke seçiniz"
                      />
                  )}
                </div>

                <div>
                      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    Şehir
                  </label>
                  {!isEditing ? (
                        <div className="w-full px-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white">
                          {editedProfile?.city || 'Belirtilmemiş'}
                        </div>
                      ) : (
                      <Select
                          options={cities.map(c => ({ value: c.name, label: c.name }))}
                          value={editedProfile?.city ? { value: editedProfile.city, label: editedProfile.city } : null}
                          onChange={(option) => setEditedProfile({ ...editedProfile, city: option.value })}
                        isDisabled={!isEditing}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        styles={customReactSelectStyles(isDark)}
                          placeholder="Şehir seçiniz"
                      />
                  )}
                    </div>
                </div>

                  <ModernInput
                    label="Posta Kodu"
                    icon={Flag}
                    value={editedProfile?.postal_code || ''}
                    onChange={(e) => setEditedProfile({
                      ...editedProfile,
                      postal_code: e.target.value,
                    })}
                    disabled={!isEditing}
                    placeholder="Örn: 34000"
                  />

                <div>
                    <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    Adres
                  </label>
                  <div className="relative">
                      <MapPin className="absolute left-4 top-4 w-5 h-5 text-gray-400" />
                    <textarea
                      value={editedProfile?.address || ''}
                        onChange={(e) => setEditedProfile({ ...editedProfile, address: e.target.value })}
                      disabled={!isEditing}
                        rows={4}
                      className={`
                          w-full pl-12 pr-4 py-3.5 rounded-xl border transition-all duration-200 resize-none
                          focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500
                          ${!isEditing
                            ? 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700 cursor-not-allowed opacity-60'
                            : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
                          }
                          text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400
                      `}
                      placeholder="Açık adresiniz"
                    />
                  </div>
                </div>
                </ModernSection>
              </div>
            )}

            {activeTab === 'work' && (
              <div className="space-y-8">
                {/* İlk Satır - 2 Eşit Bölüm */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* İş Bilgileri */}
                  <ModernSection title="İş Bilgileri" icon={Briefcase} badge="Kariyer">
                    <div className="space-y-6">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                          Pozisyon
                        </label>
                        {!isEditing ? (
                          <div className="w-full px-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white">
                            {positionOptions.find(opt => opt.value === editedProfile?.job_position)?.label || editedProfile?.job_position || 'Belirtilmemiş'}
                          </div>
                        ) : (
                          <Select
                            options={positionOptions}
                            value={positionOptions.find(opt => opt.value === editedProfile?.job_position)}
                            onChange={(option) => setEditedProfile({
                                ...editedProfile,
                                job_position: option.value,
                            })}
                            isDisabled={!isEditing}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            styles={customReactSelectStyles(isDark)}
                            placeholder="Pozisyon seçiniz"
                          />
                        )}
                      </div>

                      <ModernInput
                        label="Website"
                        icon={Globe}
                        value={editedProfile?.website || ''}
                        onChange={(e) => setEditedProfile({ ...editedProfile, website: e.target.value })}
                        disabled={!isEditing}
                        placeholder="www.orneksite.com"
                        description="Kişisel web siteniz veya portfolyo linkiniz"
                      />

                      {/* Website Önizleme */}
                      {editedProfile?.website && !isEditing && (
                        <div className="mt-2">
                          <a
                            href={formatWebsiteUrl(editedProfile.website)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 text-sm font-medium transition-colors"
                          >
                            <Globe className="w-4 h-4" />
                            {displayWebsite(editedProfile.website)}
                          </a>
                        </div>
                      )}
                    </div>
                  </ModernSection>

                  {/* Başarılar Bölümü */}
                  <ModernSection title="Başarılar" icon={Award} badge="İstatistik">
                    <div className="space-y-4">
                      {/* Profil Tamamlama Başarısı */}
                      <div className="flex items-center justify-between p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl">
                        <div className="flex items-center gap-3">
                          <div className={`p-2 bg-gradient-to-r ${calculateAchievementLevel(calculateProfileCompletion(userProfile), { bronze: 25, silver: 50, gold: 80 }).color} rounded-lg`}>
                            <Star className="w-5 h-5 text-white" />
                          </div>
                          <div>
                            <div className="flex items-center gap-2">
                              <p className="font-semibold text-gray-900 dark:text-white">Profil Uzmanı</p>
                              <span className={`px-2 py-1 rounded-full text-xs font-medium bg-gradient-to-r ${calculateAchievementLevel(calculateProfileCompletion(userProfile), { bronze: 25, silver: 50, gold: 80 }).color} text-white`}>
                                {calculateAchievementLevel(calculateProfileCompletion(userProfile), { bronze: 25, silver: 50, gold: 80 }).text}
                              </span>
                            </div>
                            <p className="text-sm text-gray-600 dark:text-gray-400">Profil tamamlanma durumu</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <span className="text-2xl font-bold text-blue-600 dark:text-blue-400">{calculateProfileCompletion(userProfile)}%</span>
                          <p className="text-xs text-white dark:text-white ">Tamamlandı</p>
                        </div>
                      </div>

                      {/* Görev Tamamlama Başarısı */}
                      <div className="flex items-center justify-between p-4 bg-green-50 dark:bg-green-900/20 rounded-xl">
                        <div className="flex items-center gap-3">
                          <div className={`p-2 bg-gradient-to-r ${calculateAchievementLevel(achievements.completedTasks, { bronze: 5, silver: 15, gold: 30 }).color} rounded-lg`}>
                            <CheckCircle2 className="w-5 h-5 text-white" />
                          </div>
                          <div>
                            <div className="flex items-center gap-2">
                              <p className="font-semibold text-gray-900 dark:text-white">Görev Ustası</p>
                              <span className={`px-2 py-1 rounded-full text-xs font-medium bg-gradient-to-r ${calculateAchievementLevel(achievements.completedTasks, { bronze: 5, silver: 15, gold: 30 }).color} text-white`}>
                                {calculateAchievementLevel(achievements.completedTasks, { bronze: 5, silver: 15, gold: 30 }).text}
                              </span>
                            </div>
                            <p className="text-sm text-gray-600 dark:text-gray-400">Tamamlanan görev sayısı</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <span className="text-2xl font-bold text-green-600 dark:text-green-400">{achievements.completedTasks}</span>
                          <p className="text-xs text-gray-500 dark:text-gray-400">Görev</p>
                        </div>
                      </div>
                    </div>
                  </ModernSection>
                </div>

                {/* İkinci Satır - 2 Eşit Bölüm */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Biyografi */}
                  <ModernSection title="Biyografi" icon={User} badge="Hakkımda">
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
                          Kendinizi Tanıtın
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            setEditingBio(true);
                            setTempBio(userProfile?.biography || '');
                          }}
                          className="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors text-gray-500 hover:text-blue-500"
                        >
                          <Settings className="w-4 h-4" />
                        </button>
                      </div>
                      
                      {editingBio ? (
                        <div className="space-y-3">
                          <textarea
                            value={tempBio}
                            onChange={(e) => setTempBio(e.target.value)}
                            className="w-full px-4 py-3 text-sm border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-y min-h-[100px] max-h-[300px] transition-all duration-200"
                            placeholder="Kendinizi tanıtın..."
                          />
                          <div className="flex justify-end gap-2">
                            <button
                              type="button"
                              onClick={() => {
                                setEditingBio(false);
                                setTempBio(userProfile?.biography || '');
                              }}
                              className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                            >
                              İptal
                            </button>
                            <button
                              type="button"
                              onClick={handleSaveBio}
                              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
                            >
                              <Check className="w-4 h-4" />
                              Kaydet
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700 min-h-[120px]">
                          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                            {userProfile?.biography || 'Henüz biyografi eklenmemiş. Kendinizi tanıtmak için düzenleme butonuna tıklayın.'}
                          </p>
                        </div>
                      )}
                    </div>
                  </ModernSection>

                  {/* Yetenekler */}
                  <ModernSection title="Yetenekler" icon={Star} badge="Beceriler">
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
                          Profesyonel Yetenekler
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            setEditingSkills(true);
                            setTempSkills(userProfile?.skills || '');
                          }}
                          className="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors text-gray-500 hover:text-blue-500"
                        >
                          <Settings className="w-4 h-4" />
                        </button>
                      </div>
                      
                      {editingSkills ? (
                        <div className="space-y-3">
                          <div className="flex flex-wrap gap-2 bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg min-h-[4rem]">
                            {tempSkills.split(',').filter(Boolean).map((skill, index) => (
                              <span
                                key={index}
                                className="px-3 py-1.5 text-xs font-medium rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 flex items-center gap-2 group"
                              >
                                {skill.trim()}
                                <button
                                  type="button"
                                  onClick={() => handleRemoveSkill(skill.trim())}
                                  className="opacity-0 group-hover:opacity-100 hover:text-red-500 transition-opacity"
                                >
                                  <X className="w-3 h-3" />
                                </button>
                              </span>
                            ))}
                          </div>
                          <div className="flex gap-2">
                            <input
                              type="text"
                              value={skillInput}
                              onChange={(e) => setSkillInput(e.target.value)}
                              onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  handleAddSkill();
                                }
                              }}
                              placeholder="Yeni yetenek ekle..."
                              className="flex-1 px-4 py-2 text-sm border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                            />
                            <button
                              type="button"
                              onClick={handleAddSkill}
                              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
                            >
                              <Plus className="w-4 h-4" />
                              Ekle
                            </button>
                          </div>
                          <div className="flex justify-end gap-2">
                            <button
                              type="button"
                              onClick={() => {
                                setEditingSkills(false);
                                setTempSkills(userProfile?.skills || '');
                                setSkillInput('');
                              }}
                              className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                            >
                              İptal
                            </button>
                            <button
                              type="button"
                              onClick={handleSaveSkills}
                              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
                            >
                              <Check className="w-4 h-4" />
                              Kaydet
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700 min-h-[120px]">
                          <div className="flex flex-wrap gap-2">
                            {userProfile?.skills?.split(',').filter(Boolean).map((skill, index) => (
                              <span
                                key={index}
                                className="px-3 py-1.5 text-xs font-medium rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400"
                              >
                                {skill.trim()}
                              </span>
                            )) || (
                              <div className="w-full flex items-center justify-center py-8">
                                <span className="text-gray-500 dark:text-gray-400 text-sm">
                                  Henüz yetenek eklenmemiş. Becerilerinizi eklemek için düzenleme butonuna tıklayın.
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </ModernSection>
                </div>

                {/* Üçüncü Satır - Tam Genişlik İstatistikler */}
                <ModernSection title="Performans İstatistikleri" icon={Activity} badge="Analiz">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {/* Katılım Oranı */}
                    <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20 rounded-xl border border-purple-200 dark:border-purple-700">
                      <div className="flex items-center justify-center mb-4">
                        <div className={`p-3 bg-gradient-to-r ${calculateAchievementLevel(achievements.participationRate, { bronze: 30, silver: 60, gold: 85 }).color} rounded-full`}>
                          <Activity className="w-6 h-6 text-white" />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <h4 className="font-semibold text-gray-900 dark:text-white">Katılım Oranı</h4>
                        <div className="text-3xl font-bold text-purple-600 dark:text-purple-400">{achievements.participationRate}%</div>
                        <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium bg-gradient-to-r ${calculateAchievementLevel(achievements.participationRate, { bronze: 30, silver: 60, gold: 85 }).color} text-white`}>
                          {calculateAchievementLevel(achievements.participationRate, { bronze: 30, silver: 60, gold: 85 }).text}
                        </span>
                      </div>
                    </div>

                    {/* Hesap Yaşı */}
                    <div className="text-center p-6 bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/20 dark:to-orange-800/20 rounded-xl border border-orange-200 dark:border-orange-700">
                      <div className="flex items-center justify-center mb-4">
                        <div className={`p-3 bg-gradient-to-r ${calculateAchievementLevel(achievements.accountAge, { bronze: 30, silver: 90, gold: 365 }).color} rounded-full`}>
                          <Clock className="w-6 h-6 text-white" />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <h4 className="font-semibold text-gray-900 dark:text-white">Hesap Yaşı</h4>
                        <div className="text-3xl font-bold text-orange-600 dark:text-orange-400">{achievements.accountAge > 0 ? achievements.accountAge : 0}</div>
                        <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium bg-gradient-to-r ${calculateAchievementLevel(achievements.accountAge, { bronze: 30, silver: 90, gold: 365 }).color} text-white`}>
                          {calculateAchievementLevel(achievements.accountAge, { bronze: 30, silver: 90, gold: 365 }).text}
                        </span>
                        <p className="text-xs text-gray-500 dark:text-gray-400">Gün</p>
                      </div>
                    </div>

                    {/* Toplam Görevler */}
                    <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 rounded-xl border border-blue-200 dark:border-blue-700">
                      <div className="flex items-center justify-center mb-4">
                        <div className="p-3 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full">
                          <Briefcase className="w-6 h-6 text-white" />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <h4 className="font-semibold text-gray-900 dark:text-white">Toplam Görevler</h4>
                        <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">{achievements.totalTasks}</div>
                        <p className="text-xs text-gray-500 dark:text-gray-400">Atanan</p>
                      </div>
                    </div>

                    {/* Son Aktivite */}
                    <div className="text-center p-6 bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 rounded-xl border border-green-200 dark:border-green-700">
                      <div className="flex items-center justify-center mb-4">
                        <div className="p-3 bg-gradient-to-r from-green-500 to-green-600 rounded-full">
                          <TrendingUp className="w-6 h-6 text-white" />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <h4 className="font-semibold text-gray-900 dark:text-white">Son 30 Gün</h4>
                        <div className="text-3xl font-bold text-green-600 dark:text-green-400">{achievements.recentActivityRate}%</div>
                        <p className="text-xs text-gray-500 dark:text-gray-400">Aktivite Oranı</p>
                      </div>
                    </div>
                  </div>
                </ModernSection>
              </div>
            )}

            {activeTab === 'contact' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <ModernSection title="İletişim Bilgileri" icon={Phone} badge="Erişim">
                  <ModernInput
                    label="E-posta"
                    icon={Mail}
                    type="email"
                    value={editedProfile?.email || ''}
                    onChange={(e) => setEditedProfile({
                      ...editedProfile,
                      email: e.target.value,
                    })}
                    disabled={!isEditing}
                    placeholder="ornek@eposta.com"
                    error={emailError}
                    required
                    description="E-posta adresiniz sisteme giriş için kullanılır"
                  />

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                      Telefon
                    </label>
                    {!isEditing ? (
                      <div className="relative">
                        <Phone className="absolute left-4 inset-y-0 my-auto w-5 h-5 text-gray-400 z-10" />

                        <div className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-900 dark:text-white">
                          {formatPhoneNumber(editedProfile?.phone)}
                        </div>
                      </div>
                    ) : (
                      <div className="relative">
                        <Phone className="absolute left-4 top-0 bottom-0 w-5 h-5 text-gray-400 z-10 flex items-center justify-center" />
                        <PhoneInput
                          country="tr"
                          value={editedProfile?.phone || ''}
                          onChange={(value) => setEditedProfile({ ...editedProfile, phone: value })}
                          containerClass="!w-full "
                          inputClass={` 
                            !w-full !pl-24 !pr-4 !py-3.5 !rounded-xl !border !h-[50px] 
                            focus:!outline-none focus:!ring-2 focus:!ring-blue-500/20 focus:!border-blue-500
                            !transition-all !duration-200 !font-medium 
                            ${isDark 
                              ? '!bg-gray-800 !border-gray-700 !text-white placeholder:!text-gray-400'
                              : '!bg-white !border-gray-200 !text-gray-900 placeholder:!text-gray-500 '
                            }
                            hover:!border-gray-300 dark:hover:!border-gray-600
                            text-left
                          `}
                          buttonClass={` 
                            !absolute !left-12 !top-1/2 !transform !-translate-y-1/2  
                            !bg-transparent !border-0 !h-auto !w-auto !p-0 
                            ${isDark ? '!text-white' : '!text-gray-900 '}
                          `}
                          dropdownClass={`
                            !z-50 !bg-white dark:!bg-gray-800 !border !border-gray-200 dark:!border-gray-700
                            !rounded-lg !shadow-lg !text-gray-900 dark:!text-white 
                          `}
                          disabled={!isEditing}
                        />
                      </div>
                    )}
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 ">
                      Telefon numaranız acil durumlarda iletişim için kullanılabilir
                    </p>
                  </div>
                </ModernSection>

                <ModernSection title="Gizlilik Tercihleri" icon={Shield} badge="Güvenlik">
                  <div className="space-y-6">
                    {/* Profil Görünürlüğü */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <div>
                        <p className="font-semibold text-gray-900 dark:text-white">Herkese Açık Profil</p>
                        <p className="text-sm text-gray-600 dark:text-gray-400">Profiliniz herkese görünür olsun</p>
                      </div>
                      <button
                        onClick={() => {
                          setPrivacySettings(prev => ({ ...prev, public_profile: !prev.public_profile }));
                          // Otomatik kaydet
                          setTimeout(() => savePrivacySettings(), 100);
                        }}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 ${
                          privacySettings.public_profile ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
                        }`}
                        disabled={isLoading}
                      >
                        <motion.span
                          initial={false}
                          animate={{ translateX: privacySettings.public_profile ? '20px' : '2px' }}
                          transition={{ type: "spring", stiffness: 500, damping: 30 }}
                          className="inline-block h-5 w-5 transform rounded-full bg-white shadow-lg"
                        />
                      </button>
                    </div>

                    {/* İletişim Bilgileri Görünürlüğü */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <div>
                        <p className="font-semibold text-gray-900 dark:text-white">Giriş Bildirimleri</p>
                        <p className="text-sm text-gray-600 dark:text-gray-400">Sisteme giriş yaptığınızda bildirim alın</p>
                      </div>
                      <button
                        onClick={() => {
                          setPrivacySettings(prev => ({ ...prev, login_notifications: !prev.login_notifications }));
                          // Otomatik kaydet
                          setTimeout(() => savePrivacySettings(), 100);
                        }}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 ${
                          privacySettings.login_notifications ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
                        }`}
                        disabled={isLoading}
                      >
                        <motion.span
                          initial={false}
                          animate={{ translateX: privacySettings.login_notifications ? '20px' : '2px' }}
                          transition={{ type: "spring", stiffness: 500, damping: 30 }}
                          className="inline-block h-5 w-5 transform rounded-full bg-white shadow-lg"
                        />
                      </button>
                    </div>

                    {/* Cihaz Geçmişi */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <div>
                        <p className="font-semibold text-gray-900 dark:text-white">Cihaz Geçmişi</p>
                        <p className="text-sm text-gray-600 dark:text-gray-400">Giriş yaptığınız cihazların geçmişi tutulsun</p>
                      </div>
                      <button
                        onClick={() => {
                          setPrivacySettings(prev => ({ ...prev, device_history: !prev.device_history }));
                          // Otomatik kaydet
                          setTimeout(() => savePrivacySettings(), 100);
                        }}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 ${
                          privacySettings.device_history ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
                        }`}
                        disabled={isLoading}
                      >
                        <motion.span
                          initial={false}
                          animate={{ translateX: privacySettings.device_history ? '20px' : '2px' }}
                          transition={{ type: "spring", stiffness: 500, damping: 30 }}
                          className="inline-block h-5 w-5 transform rounded-full bg-white shadow-lg"
                        />
                      </button>
                    </div>

                    {/* Veri Paylaşımı */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <div>
                        <p className="font-semibold text-gray-900 dark:text-white">Anonim Veri Paylaşımı</p>
                        <p className="text-sm text-gray-600 dark:text-gray-400">Uygulamayı geliştirmek için anonim kullanım verilerini paylaş</p>
                      </div>
                      <button
                        onClick={() => {
                          setPrivacySettings(prev => ({ ...prev, data_sharing: !prev.data_sharing }));
                          // Otomatik kaydet
                          setTimeout(() => savePrivacySettings(), 100);
                        }}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 ${
                          privacySettings.data_sharing ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
                        }`}
                        disabled={isLoading}
                      >
                        <motion.span
                          initial={false}
                          animate={{ translateX: privacySettings.data_sharing ? '20px' : '2px' }}
                          transition={{ type: "spring", stiffness: 500, damping: 30 }}
                          className="inline-block h-5 w-5 transform rounded-full bg-white shadow-lg"
                        />
                      </button>
                    </div>

                    {/* Aktivite İzleme */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <div>
                        <p className="font-semibold text-gray-900 dark:text-white">Aktivite İzleme</p>
                        <p className="text-sm text-gray-600 dark:text-gray-400">Sistemdeki aktiviteleriniz izlensin ve raporlansın</p>
                      </div>
                      <button
                        onClick={() => {
                          setPrivacySettings(prev => ({ ...prev, activity_tracking: !prev.activity_tracking }));
                          // Otomatik kaydet
                          setTimeout(() => savePrivacySettings(), 100);
                        }}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 ${
                          privacySettings.activity_tracking ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
                        }`}
                        disabled={isLoading}
                      >
                        <motion.span
                          initial={false}
                          animate={{ translateX: privacySettings.activity_tracking ? '20px' : '2px' }}
                          transition={{ type: "spring", stiffness: 500, damping: 30 }}
                          className="inline-block h-5 w-5 transform rounded-full bg-white shadow-lg"
                        />
                      </button>
                    </div>

                    {/* Bilgilendirme notu */}
                    <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800">
                      <div className="flex items-start gap-3">
                        <AlertCircle className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
                        <div>
                          <p className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-1">
                            Gizlilik Bildirimi
                          </p>
                          <p className="text-sm text-blue-700 dark:text-blue-300">
                            Gizlilik tercihleriniz anında kaydedilir. Bu ayarları istediğiniz zaman değiştirebilirsiniz.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ModernSection>
              </div>
            )}

            {activeTab === 'security' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <ModernSection title="Güvenlik Ayarları" icon={Lock} badge="Koruma">
                  <div className="space-y-4">
                    <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-xl border border-yellow-200 dark:border-yellow-800">
                      <div className="flex items-center gap-3 mb-2">
                        <AlertCircle className="w-5 h-5 text-yellow-600 dark:text-yellow-400" />
                        <p className="font-semibold text-yellow-800 dark:text-yellow-200">Şifre Güvenliği</p>
                      </div>
                      <p className="text-sm text-yellow-700 dark:text-yellow-300">
                        Şifrenizi düzenli olarak güncelleyin ve güçlü bir şifre kullanın.
                      </p>
                    </div>

                    <button className="w-full p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800 text-left hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-semibold text-blue-900 dark:text-blue-100">Şifre Değiştir</p>
                          <p className="text-sm text-blue-700 dark:text-blue-300">
                            Son değişiklik: {formatPasswordChangeDate(passwordLastChanged)}
                          </p>
                        </div>
                        <Lock className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                      </div>
                    </button>
                  </div>
                </ModernSection>

                <ModernSection title="Hesap Bilgileri" icon={Settings} badge="Sistem">
                  <div className="space-y-4">
                    <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <p className="text-sm text-gray-600 dark:text-gray-400">Hesap Oluşturulma</p>
                      <p className="font-semibold text-gray-900 dark:text-white">
                        {userProfile?.created_at 
                          ? new Date(userProfile.created_at).toLocaleDateString('tr-TR', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })
                          : 'Bilinmiyor'
                        }
                      </p>
                    </div>

                    <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <p className="text-sm text-gray-600 dark:text-gray-400">Son Güncelleme</p>
                      <p className="font-semibold text-gray-900 dark:text-white">
                        {userProfile?.updated_at 
                          ? new Date(userProfile.updated_at).toLocaleDateString('tr-TR', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })
                          : 'Hiç güncellenmemiş'
                        }
                      </p>
                    </div>

                    <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                      <p className="text-sm text-gray-600 dark:text-gray-400">Kullanıcı ID</p>
                      <p className="font-mono text-sm text-gray-900 dark:text-white">{userProfile?.id}</p>
                </div>
              </div>
                </ModernSection>
            </div>
            )}
          </motion.div>
        </AnimatePresence>

        {/* Save Changes Button */}
        <AnimatePresence>
            {isEditing && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50"
              >
              <div className="flex items-center gap-4 bg-white dark:bg-gray-800 rounded-2xl p-4 shadow-xl border border-gray-200 dark:border-gray-700">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => {
                    setEditedProfile({
                      ...userProfile,
                      birth_date: userProfile.birth_date ? new Date(userProfile.birth_date) : null,
                    });
                    setIsEditing(false);
                    setNewProfilePhoto(null);
                    setPreviewPhoto(null);
                    setEmailError('');
                    setIsEmailValid(true);
                    setTcError('');
                  }}
                  className="px-6 py-3 rounded-xl font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                >
                  İptal
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleSaveChanges}
                  disabled={isLoading}
                  className="px-6 py-3 rounded-xl font-medium flex items-center gap-2 text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-lg shadow-blue-500/25"
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      Kaydediliyor...
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4" />
                      Değişiklikleri Kaydet
                    </>
                  )}
                </motion.button>
              </div>
              </motion.div>
            )}
        </AnimatePresence>
      </motion.div>
    </motion.div>
  );
};

export default ProfileInfo;
